import { SectionStyleField } from "../section-style.fields";

const EmergencyBandFields = {
  message: {
    type: "text",
    label: "Message",
    metadata: {
      source: "manual",
      description:
        "The line shown beside the call button. Whether the band appears at all comes from the emergency service toggle in Business settings, not from here.",
    },
  },
  // Bold sets the band in the accent with the line in display capitals.
  variant: SectionStyleField,
} as const;

export { EmergencyBandFields };
